import { createStore } from 'vuex'

const savedTheme = localStorage.getItem('arco-theme')
const darkTheme = savedTheme === 'dark'

export default createStore({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    darkTheme
  },
  getters: {
    isLoggedIn: state => !!state.token,
    userInfo: state => state.userInfo,
    darkTheme: state => state.darkTheme
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    setDarkTheme(state, dark) {
      state.darkTheme = dark
      localStorage.setItem('arco-theme', dark ? 'dark' : 'light')
      if (dark) {
        document.body.setAttribute('arco-theme', 'dark')
      } else {
        document.body.removeAttribute('arco-theme')
      }
    },
    clearAuth(state) {
      state.token = ''
      state.userInfo = {}
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('expireTime')
    }
  },
  actions: {
    logout({ commit }) {
      commit('clearAuth')
    }
  },
  modules: {
  }
})
